import { IconExternalLink } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { EPDDocumentOUT } from "api-client";
import SearchSortTable from "components/Table";
import { ColumnDef } from "@tanstack/react-table";

const DocumentsTable = (props: { documents: EPDDocumentOUT[] }) => {
  const { t } = useTranslation();

  const getColumns = () =>
    React.useMemo<ColumnDef<EPDDocumentOUT>[]>(
      () => [
        {
          id: "title",
          cell: (info: { row: { original: EPDDocumentOUT } }) =>
            info.row.original.title,
          header: () => <div>{t("mapping.document")}</div>,
          enableColumnFilter: false,
          enableSorting: false,
          maxSize: 300,
          minSize: 240,
        },
        {
          id: "source",
          cell: (info: { row: { original: EPDDocumentOUT } }) =>
            info.row.original?.provider === "Sentinel"
              ? "Sentinel Holding Institut (SHI)"
              : info.row.original?.provider,
          header: () => <div>{t("mapping.source")}</div>,
          enableColumnFilter: false,
          enableSorting: false,
          minSize: 220,
        },
        {
          id: "url",
          cell: (info: { row: { original: EPDDocumentOUT } }) => (
            <div className="flex justify-center">
              <IconExternalLink
                className="cursor-pointer text-indigo-700"
                stroke={3}
                size={15}
                onClick={() =>
                  info.row.original?.link &&
                  window.open(info.row.original.link, "_blank")
                }
              />
            </div>
          ),
          maxSize: 35,
          enableColumnFilter: false,
          enableSorting: false,
        },
      ],
      []
    );

  return (
    <div className="w-full mb-6 border-b border-gray-200 pb-4">
      <div className="text-base font-semibold mb-3 text-gray-900">
        {t("mapping.documentWithMoreInfo")}
      </div>
      <div className="border !rounded-md border-gray-300 text-gray-900 text-xs overflow-hidden w-full">
        <SearchSortTable
          data={props.documents}
          getColumns={getColumns as () => ColumnDef<unknown, unknown>[]}
          headerRowStyle="bg-white whitespace-nowrap"
          headerColumnStyle="border-r last-of-type:border-r-0"
          headerDivStyle="!py-1"
          customColumnStyle="border-r last-of-type:border-r-0 whitespace-nowrap !py-1 !px-2"
          enableTooltip
        />
      </div>
    </div>
  );
};

export default observer(DocumentsTable);
